import { buttonOverrides } from "./button";
import { chipOverrides } from "./chip";
import { formHelperTextOverrides } from "./form-helper-text";
import { formLabelOverrides } from "./form-label";

export const componentOverrides = {
	components: {
		...buttonOverrides,
		...chipOverrides,
		...formLabelOverrides,
		...formHelperTextOverrides,
	},
};
